<template>
  <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
    <div class="px-4 py-3 border-b border-gray-200">
      <div class="flex justify-between items-center">
        <h2 class="heading-section">Agents</h2>
        <button
          class="btn-primary-sm"
          @click="openAgentModal(null)"
        >
          <font-awesome-icon icon="plus" />
          New Agent
        </button>
      </div>
    </div>
    <div>
      <ag-grid-vue
        style="width: 100%; height: 100%"
        :theme="theme"
        :columnDefs="columnDefs"
        :rowData="agents"
        :defaultColDef="defaultColDef"
        :grid-options="{ domLayout: 'autoHeight', context: { openAgentModal }, suppressCellFocus: true }"
        @row-clicked="$emit('open-agent-modal', $event.data.id)"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
import CellStatusBadge from '@/components/Outreach/Cells/CellStatusBadge.vue'
import CellButton from '@/components/Outreach/Cells/CellButton.vue'
import { formatRelativeTime } from '@/utils/date'
import { formatLabel } from '@/utils/string'
import { standardListTheme } from '@/utils/common'

export default {
  name: 'AgentsCard',
  components: {
    AgGridVue,
  },
  props: {
    agents: {
      type: Array,
      required: true,
    },
  },
  emits: ['agents-updated', 'open-agent-modal'],
  data() {
    return {
      theme: standardListTheme,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: true,
      },
      columnDefs: [
        { field: 'name', headerName: 'Name', flex: 2 },
        {
          field: 'handoff_names',
          headerName: 'Handoffs',
          valueGetter: (params) => params.data.handoff_names?.length || 0,
          flex: 1
        },
        {
          field: 'tool_names',
          headerName: 'Tools',
          valueGetter: (params) => params.data.tool_names?.length || 0,
          flex: 1
        },
        {
          field: 'status',
          headerName: 'Status',
          valueGetter: (params) => formatLabel(String(params.data.status || '')),
          cellRenderer: CellStatusBadge,
          cellRendererParams: {
            variant: 'call-config'
          },
          filter: 'agSetColumnFilter',
          flex: 1
        },
        {
          field: 'updated_at',
          headerName: 'Updated',
          valueGetter: (params) => {
            return params.data.updated_at ? new Date(String(params.data.updated_at)) : null
          },
          valueFormatter: (params) => {
            return params.data.updated_at ? formatRelativeTime(String(params.data.updated_at)) : '-'
          },
          filter: 'agDateColumnFilter',
          flex: 1
        },
        {
          field: 'actions',
          headerName: 'Actions',
          cellRenderer: CellButton,
          cellRendererParams: {
            icon: 'pen-to-square',
            onClick: (data) => this.openAgentModal(data.id)
          },
          sortable: false,
          filter: false,
          width: 100
        },
      ],
    }
  },
  methods: {
    openAgentModal(agentId) {
      this.$emit('open-agent-modal', agentId)
    },
  },
}
</script>
